import { STATUS_COLORS, FEATURE_COLORS, FEATURE_FALLBACK } from '../constants/map';

export function getFeatureColor(feature) {
	if (!feature) return STATUS_COLORS.none;
	return FEATURE_COLORS[feature] || FEATURE_FALLBACK;
}

export function computeActivityStatus(act, filterActivityStatus) {
	const status = act.Status ?? act.status;

	// Closed mode — only Closed activities arrive, label them accordingly
	if (filterActivityStatus === 'Closed') {
		return status === 'Closed' ? 'closed' : 'none';
	}

	// Open mode — original logic
	if (status !== 'Open') return 'none';
	const today  = new Date().setHours(0, 0, 0, 0);
	const rawEnd = act.EndDate ?? act.endDate;
	const end    = rawEnd ? new Date(rawEnd).getTime() : null;
	if (end !== null && end < today) return 'none';
	const start  = new Date(act.StartDate ?? act.startDate).getTime();
	if (start <= today) return 'inprogress';
	return 'planned';
}

export function computeStatus(site, displayStart, displayEnd, filterActivityStatus) {
	if (!site.activitiesCount || site.activitiesCount === 0) return 'none';
	if (!site.activityStartDate && !site.activityEndDate) {
		if (filterActivityStatus === 'Closed') {
			const ov = site.hasOverdue ?? site.HasOverdue ?? false;
			if (!ov) return 'none';
			const dS = displayStart ? new Date(displayStart).getTime() : null;
			const dE = displayEnd   ? new Date(displayEnd).getTime()   : null;
			const cStart = site.closedStartDate ?? site.ClosedStartDate ?? null;
			const cEnd   = site.closedEndDate   ?? site.ClosedEndDate   ?? null;
			const csMs = cStart ? new Date(cStart).getTime() : null;
			const ceMs = cEnd   ? new Date(cEnd).getTime()   : null;
			const inWin = (!dS || ceMs === null || ceMs >= dS)
			           && (!dE || csMs === null || csMs <= dE);
			return inWin ? 'overdue' : 'none';
		}
		return 'none';
	}

	const todayMs = new Date().setHours(0, 0, 0, 0);
	const aStart  = site.activityStartDate ? new Date(site.activityStartDate).getTime() : null;
	const aEnd    = site.activityEndDate   ? new Date(site.activityEndDate).getTime()   : null;
	const dStart  = displayStart ? new Date(displayStart).getTime() : null;
	const dEnd    = displayEnd   ? new Date(displayEnd).getTime()   : null;

	if (filterActivityStatus === 'Closed') {
		// Closed mode — use closed activity dates for window check
		const ov = site.hasOverdue ?? site.HasOverdue ?? false;
		if (!ov) return 'none';
		const cStart = site.closedStartDate ?? site.ClosedStartDate ?? null;
		const cEnd   = site.closedEndDate   ?? site.ClosedEndDate   ?? null;
		const csMs   = cStart ? new Date(cStart).getTime() : null;
		const ceMs   = cEnd   ? new Date(cEnd).getTime()   : null;
		// inWindow check using closed dates
		const inClosedWindow = (!dStart || ceMs === null || ceMs >= dStart)
		                    && (!dEnd   || csMs === null || csMs <= dEnd);
		return inClosedWindow ? 'overdue' : 'none';
	}

	const inWindow = (!dStart || aEnd === null || aEnd   >= dStart)
                && (!dEnd   || !aStart      || aStart <= dEnd);

	// Open mode
	if (!inWindow) return 'none';
	if (site.activityStatus !== 'Open') return 'none';
	if (aEnd !== null && aEnd < todayMs) return 'none';
	if (aStart !== null && aStart <= todayMs) return 'inprogress';
	if (aStart !== null && aStart > todayMs)  return 'planned';
	return 'none';
}

// A site is overdue if backend says so, or if we can compute it locally
export function computeOverdue(site) {
	// Use backend field if available
	if (site.hasOverdue != null) return site.hasOverdue;
	if (site.HasOverdue != null) return site.HasOverdue;
	// Fallback: compute locally
	if (!site.activitiesCount || site.activitiesCount === 0) return false;
	const todayMs = new Date().setHours(0, 0, 0, 0);
	if (site.activityStatus !== 'Open') return true;
	const aEnd = site.activityEndDate ? new Date(site.activityEndDate).getTime() : null;
	if (aEnd !== null && aEnd < todayMs) return true;
	return false;
}

export function normaliseSite(site, displayStart, displayEnd, filterActivityStatus) {
	const feature = site.dominantFeature  != null ? site.dominantFeature
		: site.DominantFeature  != null ? site.DominantFeature
			: site.dominant_feature != null ? site.dominant_feature
				: site.Feature          != null ? site.Feature
					: null;
	const title = site.dominantTitle  != null ? site.dominantTitle
		: site.DominantTitle  != null ? site.DominantTitle
			: null;
	return {
		...site,
		tac:      site.tac != null ? site.tac : site.tAC,
		_status:  computeStatus(site, displayStart, displayEnd, filterActivityStatus),
		_feature: feature,
		_title:   title,
		_overdue: computeOverdue(site),
	};
}